import { render, staticRenderFns } from "../motivesAndSubmotives/motivesAndSubmotives.html?vue&type=template&id=e9d608dc&scoped=true&external"
import script from "../motivesAndSubmotives/motivesAndSubmotives.js?vue&type=script&lang=js&external"
export * from "../motivesAndSubmotives/motivesAndSubmotives.js?vue&type=script&lang=js&external"
import style0 from "../motivesAndSubmotives/motivesAndSubmotives.css?vue&type=style&index=0&id=e9d608dc&prod&scoped=true&lang=css&external"
import style1 from "./MotivesAndSubmotives.vue?vue&type=style&index=1&id=e9d608dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d608dc",
  null
  
)

export default component.exports